var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-center"},[_c('TaskList',{attrs:{"is-owner":false,"is-publish":false,"table-attr":{ height: '100%' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }